import { useEffect } from "react";

import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { KeyLockersQueryKeys } from "modules/KeyLockersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useCcSettingsQuery = () => {
  const { selectedLocation } = useSelectedLocation();

  const query = useTypedQuery({
    queryKey: KeyLockersQueryKeys.ccSettings,
    queryFn: async ({ baseUrl, endpoint }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id }, baseUrl)).data.settings,
    enabled: false
  });

  useEffect(() => {
    if (selectedLocation?.id) query.refetch();
  }, [selectedLocation]);

  return query;
};
